import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { GymeaEduDashboard } from "../components/gymea-edu-dashboard";
import { HeroSection, HomeMarketingSections } from "../components/home";
import { PageLayout } from "../components/page-layout";
import { PublicTrialProvider } from "../contexts/PublicTrialContext";
import "../styles/components/home/index.css";

export const HomePage: React.FC = () => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();
  const heroRef = React.useRef<HTMLElement>(null);

  const handleSignUp = async (e?: React.MouseEvent<HTMLButtonElement>) => {
    if (e) {
      e.preventDefault();
    }
    await loginWithRedirect({
      appState: {
        returnTo: "/dashboard",
      },
      authorizationParams: {
        screen_hint: "signup",
      },
    });
  };

  const handleDashboardSectionClick = (sectionId: string) => {
    if (isAuthenticated) {
      navigate(`/dashboard#${sectionId}`);
    }
  };

  const trialDashboard = (
    <GymeaEduDashboard
      publicMode
      onSectionClick={isAuthenticated ? handleDashboardSectionClick : undefined}
    />
  );

  return (
    <PageLayout fullWidth={true} className="home-layout">
      <div className="home-page-container">
        <HeroSection
          heroRef={heroRef}
          handleSignUp={handleSignUp}
        />

        <section className="home-dashboard-section" aria-label="Try Gymea Edu">
          <div className="home-dashboard-intro">
            <p className="home-dashboard-kicker">Let's create</p>
          </div>
          {isAuthenticated ? trialDashboard : <PublicTrialProvider>{trialDashboard}</PublicTrialProvider>}
        </section>

        <HomeMarketingSections
          handleSignUp={handleSignUp}
          showDocumentPreview={false}
        />
      </div>
    </PageLayout>
  );
};
